export default __webpack_public_path__ + "static/media/logo512.134511ad.png";